const services = [
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Conseil en gestion',
    description:
      "Accompagnement dans l'organisation et la gestion de l'activité pour une meilleure performance opérationnelle et une vision structurée.",
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Conseil stratégique',
    description:
      "Aide à la prise de décision et au développement de l'entreprise avec une approche méthodique et une vision claire de vos objectifs.",
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Optimisation des activités',
    description:
      "Analyse et amélioration des processus pour gagner en efficacité, réduire les coûts et renforcer la compétitivité de votre entreprise.",
  },
];

export default function ServicesSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#1A2B4A] mb-3">
            Nos prestations
          </p>
          <h2 className="font-poppins text-3xl lg:text-4xl font-semibold text-[#1A2B4A]">
            Nos Services
          </h2>
          <div className="w-12 h-0.5 bg-[#1A2B4A] mx-auto mt-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#F8F9FA] rounded-lg p-10 flex flex-col items-center text-center group hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A2B4A] mb-6">
                <i className={`${service.icon} text-white text-xl`}></i>
              </div>
              <h3 className="font-poppins text-lg font-semibold text-[#1A2B4A] mb-4">
                {service.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
